<template>
  <WdsStack direction-column align-center>
    <WdsHeading as="div" type="title1">
      {{ $t('Welcome back to Worksome, the home of flexible work!') }}
    </WdsHeading>
    <div class="tw-w-full tw-relative">
      <img src="@/assets/login-graphic.png" class="tw-mt-7 tw-w-full -tw-left-3 tw-absolute"/>
    </div>
  </WdsStack>
</template>

<script>
import { WdsStack, WdsHeading } from '@worksome/wds-components'

export default {
  name: 'LeftWelcome',
  components: {
    WdsStack,
    WdsHeading,
  },
}
</script>

<style lang="scss" scoped>
</style>
